<template>
<div>
    <h1 class="display-heading">Dashboard</h1>

    <div class="card mb-4">
        <div class="card-body">
            <h5 class="mb-3">Upcoming Appointments</h5>
            <div class="d-md-none">
                <div class="card mb-3" v-for="(appointment, index) in upcomingAppointments" :key="index">
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="label-display">
                                Date
                            </label>
                            <div>
                                 {{appointment.startDate}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Time
                            </label>
                            <div>
                                 {{appointment.startTime}}
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="label-display">
                                Patient Name
                            </label>
                            <div>
                                 {{appointment.patientName}}
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="label-display">
                                Status
                            </label>
                            <div class="mt-2">
                                <span class="badge text-nowrap" :class="getEnumBadgeClass(appointment.appointmentStatus)">
                                    {{getStatusDisplay(appointment.appointmentStatus)}}
                                </span>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="label-display">
                                Phone Number
                            </label>
                            <div>
                                 {{appointment.patientContact}}
                            </div>
                        </div>

                        <div>
                            <label class="label-display">
                                Action
                            </label>
                            <div class="mt-2">
                                <router-link v-if="appointment.isNewRequest" :to="{'name': 'doctor-appointment-detail', 'params': {'id': appointment.appointmentId}}" class="btn btn-primary btn-primary-insv">
                                    View Request
                                </router-link>
                                <template v-else>
                                    <a v-if="appointment.isReadyForConsultation" href="javascript: void(0);" @click="startSession(appointment.sessionId, appointment.consultationType)" class="btn btn-primary btn-primary-insv">
                                        Start Session
                                    </a>

                                    <template v-else>
                                        <span class="font-italic">No Action</span>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <p v-if="upcomingAppointments.length === 0">You have no upcoming appointments.</p>
            </div>

            <div class="d-none d-md-block">
                <div class="table-responsive-sm">
                    <table class="table table-sm" v-if="upcomingAppointments.length > 0">
                        <colgroup>
                            <col width="40">
                            <col width="140">
                            <col width="140">
                            <col>
                            <col width="140">
                            <col width="140">
                            <col width="140">
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Time</th>
                                <th scope="col">Patient Name</th>
                                <th scope="col">Status</th>
                                <th scope="col">Phone Number</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(appointment, index) in upcomingAppointments" :key="index">
                                <td>{{index+1}}</td>
                                <td class="text-nowrap">{{appointment.startDate}}</td>
                                <td class="text-nowrap">{{appointment.startTime}}</td>
                                <td class="text-nowrap">{{appointment.patientName}}</td>
                                <td class="text-nowrap">
                                    <span class="badge text-nowrap" :class="getEnumBadgeClass(appointment.appointmentStatus)">
                                        {{getStatusDisplay(appointment.appointmentStatus)}}
                                    </span>
                                </td>
                                <td class="text-nowrap">{{appointment.patientContact}}</td>
                                <td class="text-nowrap">
                                    <router-link v-if="appointment.isNewRequest" :to="{'name': 'doctor-appointment-detail', 'params': {'id': appointment.appointmentId}}">View Request</router-link>
                                    <template v-else>

                                        <a v-if="appointment.isReadyForConsultation" href="javascript: void(0);" @click="startSession(appointment.sessionId, appointment.consultationType)">Start Session</a>

                                        <template v-else>
                                            <span class="font-italic">No Action</span>
                                        </template>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-else>You have no upcoming appointments.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="card mb-4">
        <div class="card-body">
            <h5 class="mb-3">Cancelled Appointments</h5>

            <div class="d-md-none">
                <div class="card mb-3" v-for="(appointment, index) in cancelledAppointments" :key="index">
                    <div class="card-body">
                        <div class="mb-3">
                            <label class="label-display">
                                Date
                            </label>
                            <div>
                                 {{appointment.startDate}}
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="label-display">
                                Time
                            </label>
                            <div>
                                 {{appointment.startTime}}
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="label-display">
                                Patient Name
                            </label>
                            <div>
                                 {{appointment.patientName}}
                            </div>
                        </div>

                        <div>
                            <label class="label-display">
                                Phone Number
                            </label>
                            <div>
                                 {{appointment.patientContact}}
                            </div>
                        </div>
                    </div>
                </div>
                <p v-if="cancelledAppointments.length === 0">You have no upcoming appointments.</p>
            </div>

            <div class="d-none d-md-block">
                <div class="table-responsive-sm">
                    <table class="table table-sm" v-if="cancelledAppointments.length > 0">
                        <colgroup>
                            <col width="40">
                            <col width="140">
                            <col width="140">
                            <col>
                            <col width="140">
                            <col width="140">
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Date</th>
                                <th scope="col">Time</th>
                                <th scope="col">Patient Name</th>
                                <th scope="col">Phone Number</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(appointment, index) in cancelledAppointments" :key="index">
                                <td>{{index+1}}</td>
                                <td class="text-nowrap">{{appointment.startDate}}</td>
                                <td class="text-nowrap">{{appointment.startTime}}</td>
                                <td class="text-nowrap">{{appointment.patientName}}</td>
                                <td class="text-nowrap">{{appointment.patientContact}}</td>
                                <td class="text-nowrap">
                                    -
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-else>You have no cancelled appointments.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Time Slots</h5>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalTimeslotsInAWeek}}</span>
                            <span class="ml-3">Slot<span v-if="totalTimeslotsInAWeek>1">s</span> This Week</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Patients To Date
                        <small>(based on name of individual)</small>
                    </h5>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalPatientsToDate}}</span>
                            <span class="ml-3">Total Patient<span v-if="totalPatientsToDate>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Video Consultations This Month</h5>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalVideoConsultationThisMonth}}</span>
                            <span class="ml-3">Consultation<span v-if="totalVideoConsultationThisMonth>1">s</span> This Month</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Patients To Date</h5>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalPatientsToDate}}</span>
                            <span class="ml-3">Total Patients</span>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
    <!-- <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Video Consultations</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalVideoConsultation" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalConsultations">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{paidConsultations.count}}</span>
                            <span class="ml-3">Video Consultations</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Purchase of Medicines</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalPurchasedMedicine" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalPurchasedMedicine">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{paidPrescriptions.count}}</span>
                            <span class="ml-3">Purchases</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="row">
        <div class="col-sm-6">
            <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Outstanding Payment</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalOutstandingPaymentPicker" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalOutstandingPayment">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">RM{{totalOutstandingPayment.amount.toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Received Payment</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalReceivedPaymentPicker" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalReceivedPayment">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">RM{{totalReceivedPayment.amount.toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    doctorDashboardAppointmentStatus,
    getEnumBadgeClass,
    getEnumDisplay
} from '@/config/enums';
import moment from 'moment';
import datetimePicker from '@/components/datetime-picker';
import { convertToUserReadableDate, convertToUserReadableTime } from '@/utilities';
export default {
    'name': 'UserDashboard',
    'components': {
        datetimePicker
    },
    data () {
        return {
            'shouldUpdateDashboard': true,
            'upcomingAppointments': [],
            'cancelledAppointments': [],
            'paidConsultations': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'paidPrescriptions': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalTimeslotsInAWeek': 0,
            'totalPatientsToDate': 0,
            'totalVideoConsultationThisMonth': 0,
            'totalOutstandingPayment': {
                'startDate': null,
                'endDate': null,
                'amount': 0
            },
            'totalReceivedPayment': {
                'startDate': null,
                'endDate': null,
                'amount': 0
            }
        };
    },
    mounted () {
        this.getDashboard();

        this.recursiveUpdate();
    },
    beforeRouteLeave (to, from, next) {
        this.shouldUpdateDashboard = false;
        next();
    },
    'methods': {
        recursiveUpdate () {
            if (this.shouldUpdateDashboard) {
                setTimeout(() => {
                    this.axios.get('Dashboard/GetDoctorDashboardUpcomingAppointments').then(({ data }) => {
                        this.setDoctorDashboardUpcomingAppointments(data.data);

                        this.recursiveUpdate();
                    });
                }, 5000);
            }
        },
        getStatusDisplay (appointmentStatus) {
            return getEnumDisplay(doctorDashboardAppointmentStatus, appointmentStatus);
        },
        getEnumBadgeClass (appointmentStatus) {
            return getEnumBadgeClass(doctorDashboardAppointmentStatus, appointmentStatus);
        },
        getDashboard () {
            this.axios.get('Dashboard/GetDoctorDashboard').then(({ data }) => {
                this.setDoctorDashboardUpcomingAppointments(data.data.ua);

                this.cancelledAppointments = data.data.ca ? data.data.ca.map((a) =>
                    ({
                        'startDate': a.ss ? convertToUserReadableDate(a.ss) : '-',
                        'startTime': a.ss ? convertToUserReadableTime(a.ss) : '-',
                        'appointmentId': a.ai,
                        'patientName': a.cp ? a.cp.fn : '-',
                        'patientContact': a.cp ? a.cp.pn : '-',
                        'appointmentStatus': a.si,
                        'sessionId': a.sid
                    })) : [];

                this.totalTimeslotsInAWeek = data.data.tt.c;

                this.totalPatientsToDate = data.data.tp.c;

                this.totalVideoConsultationThisMonth = data.data.tc.c;

                if (data.data.top) {
                    this.setTotalOutstandingPayment(data.data.top);
                }

                if (data.data.tpc) {
                    this.setTotalReceivedPayment(data.data.tpc);
                }
            });
        },
        setVideoConsultation (consultationCount) {
            this.paidConsultations.count = consultationCount.c;
            this.paidConsultations.startDate = moment(consultationCount.sd);
            this.paidConsultations.endDate = moment(consultationCount.ed);

            if (this.$refs.totalVideoConsultation) {
                this.$refs.totalVideoConsultation.setDate(this.paidConsultations.startDate, this.paidConsultations.endDate);
            }
        },
        viewTotalPurchasedMedicine () {
            let { startDate, endDate } = this.$refs.totalPurchasedMedicine.getDates();
            this.axios.post('Dashboard/GetUserDashboardTotalMedicinePayments',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setPurchasedMedicine(data.data);
            });
        },
        setTotalOutstandingPayment (data) {
            this.totalOutstandingPayment.startDate = moment(data.sd);
            this.totalOutstandingPayment.endDate = moment(data.ed);
            this.totalOutstandingPayment.amount = data.a;

            if (this.$refs.totalOutstandingPaymentPicker) {
                this.$refs.totalOutstandingPaymentPicker.setDate(this.totalOutstandingPayment.startDate, this.totalOutstandingPayment.endDate);
            }
        },
        viewTotalOutstandingPayment () {
            let { startDate, endDate } = this.$refs.totalOutstandingPaymentPicker.getDates();

            this.axios.post('Dashboard/GetDoctorTotalOutstandingPayments',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalOutstandingPayment(data.data);
            });
        },
        setTotalReceivedPayment (data) {
            this.totalReceivedPayment.startDate = moment(data.sd);
            this.totalReceivedPayment.endDate = moment(data.ed);
            this.totalReceivedPayment.amount = data.a;

            if (this.$refs.totalReceivedPaymentPicker) {
                this.$refs.totalReceivedPaymentPicker.setDate(this.totalReceivedPayment.startDate, this.totalReceivedPayment.endDate);
            }
        },
        viewTotalReceivedPayment () {
            let { startDate, endDate } = this.$refs.totalReceivedPaymentPicker.getDates();

            this.axios.post('Dashboard/GetDoctorTotalDisbursedPayments',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalReceivedPayment(data.data);
            });
        },
        startSession (consultationId, consultationTypeId) {
            this.axios.post('Consultation/StartConsultation', null, {
                'params': {
                    'consultationId': consultationId
                }
            }).then(() => {
                this.$router.push({
                    'name': consultationTypeId === 2 ? 'doctor-consultation-no-pharmacy-detail' : 'doctor-consultation-detail',
                    'params': {
                        'id': consultationId
                    }
                });
            }).catch(({
                response
            }) => {

            });
        },
        setDoctorDashboardUpcomingAppointments (appointments) {
            this.upcomingAppointments = appointments ? appointments.map((a) =>
                ({
                    'startDate': a.ss ? convertToUserReadableDate(a.ss) : '-',
                    'startTime': a.ss ? convertToUserReadableTime(a.ss) : '-',
                    'appointmentId': a.ai,
                    'patientName': a.cp ? a.cp.fn : '-',
                    'patientContact': a.cp ? a.cp.pn : '-',
                    'appointmentStatus': a.si,
                    'sessionId': a.sid,
                    'isReadyForConsultation': a.si === 1000,
                    'isNewRequest': a.si === 0,
                    'consultationType': a.dc ? a.dc.ct : 0
                })) : [];
        }
    }
};
</script>

<style>

</style>
